import { BaseMutationTypes } from '../BaseMutationTypes';

export class DocumentToStoreMutationTypes extends BaseMutationTypes {
  public static readonly SetIsDirty = 'SET_IS_DIRTY';
  public static readonly SetIsReadonly = 'SET_IS_READONLY';
  public static readonly SetExtendingDocumentLock = 'SET_EXTENDING_DOCUMENT_LOCK';
  public static readonly ExtendDocumentLock = 'EXTEND_DOCUMENT_LOCK';
  public static readonly ExpireDocumentLock = 'EXPIRE_DOCUMENT_LOCK';
  public static readonly SetComponentName = 'SET_COMPONENT_NAME';
  public static readonly SetErrorModel = 'SET_ERROR_MODEL';
  public static readonly DocumentToStoreLoaded = 'DOCUMENT_TO_STORE_LOADED';
  public static readonly DocumentToStoreError = 'DOCUMENT_TO_STORE_ERROR';
  public static readonly SetDocumentToStoreView = 'SET_DOCUMENT_TO_STORE_VIEW';
  public static readonly SetDynamicFormSchema = 'SET_DYNAMIC_FORM_SCHEMA';
  public static readonly SetMultiValueReferenceValues = 'SET_MULTI_VALUE_REFERENCE_VALUES';
  public static readonly SetSchemaValueFromReference = 'SET_SCHEMA_VALUE_FROM_REFERENCE';
  public static readonly SetDocumentDateValue = 'SET_DOCUMENT_DATE_VALUE';
  public static readonly SetSourceDocumentTypeId = 'SET_SOURCE_DOCUMENT_TYPE_ID';
  public static readonly SetExistingDocumentId = 'SET_EXISTING_DOCUMENT_ID';
  public static readonly SetExistingDocumentOption = 'SET_EXISTING_DOCUMENT_OPTION';
  public static readonly SetInitialSchemaValues = 'SET_INITIAL_SCHEMA_VALUES';
  public static readonly SetInitialMultiValueReferences = 'SET_INITIAL_MULTI_VALUE_REFERENCES';
  public static readonly SetKeepPagesAfterStoring = 'SET_KEEP_PAGES_AFTER_STORING';
  public static readonly SetSelectedPages = 'SET_SELECTED_PAGES';
  public static readonly SetPagesStoreMode = 'SET_PAGES_STORE_MODE';
  public static readonly SetDocumentStatus = 'SET_DOCUMENT_SATUS';
  public static readonly SetPageViewedBeforeAddToExisting = 'SET_PAGE_VIEWED_BEFORE_ADD_TO_EXISTING';
  public static readonly SetAllPagesSelectedWithManualPageSelection = 'SET_ALL_PAGES_SELECTED_WITH_MANUAL_INDEXING';
  public static readonly SetAllPagesSelectedWithBatchSplitting = 'SET_ALL_PAGES_SELECTED_WITH_BATCH_SPLITTING';
  public static readonly SetReferencesForNextDocument = 'SET_REFERENCES_FOR_NEXT_DOCUMENT';
  public static readonly SetMultiValueReferencesForNextDocument = 'SET_MULTI_VALUE_REFERENCES_FOR_NEXT_DOCUMENT';
  public static readonly ApplyReferencesToNextDocumentEnabled = 'APPLY_REFERENCES_TO_NEXT_DOCUMENT_ENABLED';
  public static readonly ClearReferencesForNextDocument = 'CLEAR_REFERENCES_FOR_NEXT_DOCUMENT';
}
